import React, {useEffect, useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from 'reactstrap';
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";


function EditDepartment(props) {
    const [department, setDepartment] = useState("");
    const [load, setLoad] = useState(false);


    useEffect(() => {
        fetchDepartment()
    }, [])


    const fetchDepartment = async () => {

        const docRef = doc(getDb(), "departments", props?.item?.id);
        const querySnapshot = await getDoc(docRef);
        const _department = querySnapshot.data();
        setDepartment(_department.department)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoad(true);
        const docRef = doc(getDb(), "departments", props?.item?.id);
        let dataCapital=department.charAt(0).toUpperCase() + department.slice(1)
        await updateDoc(docRef, {
            department: dataCapital
        });
        props.getDepartments();
        setLoad(false)
        props.toggle()
        setDepartment("")
    };

    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Edit Department</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>

                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Department Name
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength={20}
                                    value={department}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setDepartment(e.target.value)}
                                />

                            </FormGroup>
                        </div>

                        <Button color="primary" type="submit" disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm"/>
                            ) : (
                                "Save"
                            )}

                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>

            </Modal>
        </div>);
}


export default EditDepartment;